import * as yup from 'yup';

export const installationSchema = yup.object().shape({
	street: yup.string().required('Address is required.'),
	city: yup.string().required('City is required.'),
	state: yup.string().required('State is required.'),
	zip: yup
		.string()
		.required('Zip code is required.')
		.matches(/[0-9]{5}/g, 'Invalid Zip Code.'),
});
